document.addEventListener('DOMContentLoaded', function () {
    // Variables Declaration
    let selectedCategory = 'All';
    let pageNumber = 1;

    // Utility Functions
    function fetchPosts(category) {
        let formData = new FormData();
        formData.append('action', 'filter_news');
        formData.append('category', category);

        fetch(frontendajax.ajaxurl, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    let postContainer = document.querySelector('.post-container');
                    postContainer.innerHTML = data.data.html;
                    document.querySelector('.load-more-posts').style.display = data.data.has_more ? 'block' : 'none';
                } else {
                    console.error('Error: AJAX response marked as unsuccessful.');
                }
            })
            .catch((error) => {
                console.error('There was an error fetching posts:', error);
            });
    }

    // Event Listeners
    let loadMoreButton = document.querySelector('.load-more-posts');
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
            pageNumber++;
            let formData = new FormData();
            formData.append('action', 'filter_news');
            formData.append('category', selectedCategory);
            formData.append('paged', pageNumber);

            fetch(frontendajax.ajaxurl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        let postContainer = document.querySelector('.post-container');
                        postContainer.innerHTML += data.data.html;
                        document.querySelector('.load-more-posts').style.display = data.data.has_more ? 'block' : 'none';
                    } else {
                        console.error('Error: AJAX response marked as unsuccessful.');
                    }
                })
                .catch((error) => {
                    console.error('There was an error fetching posts:', error);
                });
        });
    }

    document.querySelectorAll('.tab-link').forEach(function (tabLink) {
        tabLink.addEventListener('click', function (event) {
            event.preventDefault();

            // Remove active class from all tabs
            document.querySelectorAll('.tab-link').forEach(function (tab) {
                tab.classList.remove('active');
            });

            // Add active class to the clicked tab
            this.classList.add('active');

            // Update selected category and fetch posts
            selectedCategory = this.getAttribute('data-category');
            pageNumber = 1;
            fetchPosts(selectedCategory);
        });
    });
});
